import { Box, Breadcrumbs, Stack, Typography } from '@mui/material';
import React from 'react';

const NotificationScreen = () => {
  return (
    <Box>
      <Box
        className='content-horizontal-margin'
        sx={{
          display: 'flex',
          flexDirection: 'column',
          rowGap: 3,
          mt: 3,
          mb: 3,
        }}
      >
        <Breadcrumbs aria-label='breadcrumb'>
          <Typography variant='s16_w500_orange'>Notification</Typography>
        </Breadcrumbs>
        <Typography variant='s24_w600' color='secondary'>
          Notification
        </Typography>
        <Stack display='flex' justifyContent='center' alignItems='center'>
          <Typography
            variant='s24_w600'
            color='secondary'
            component='span'
            p={5}
          >
            In Development
          </Typography>
        </Stack>
      </Box>
    </Box>
  );
};

export default NotificationScreen;
